import styled from 'styled-components';
import { blurBox } from 'styles/parcelSharedStyles';
import iconLocationSVG from 'icons/location.svg';
import { ReactSVG } from 'react-svg';
import CustomScrollbar from 'components/CustomScrollbar';

export const ShipmentDetailsContainer = styled(CustomScrollbar)`
  ${blurBox}
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DetailsContainer = styled.div`
  flex-grow: 1;
`;

export const CTAButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CustomTextContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
`;

export const Location = styled.div<{ isClickable: boolean }>`
  margin-top: 8px;
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.configs.fonts.fontSize.additionalDetails}px;
`;

export const LocationIcon = styled(ReactSVG).attrs((props) => {
  return {
    src: iconLocationSVG,
    ...props,
  };
})`
  svg {
    fill: currentColor;
  }
`;

export const CustomLocationIcon = styled.img`
  widht: 24px;
  height: 24px;
`;

export const City = styled.div`
  margin-left: 8px;
`;
